import { Reveal } from "./Reveal";
import { GOOGLE_FORM_URL } from "@/lib/links";
import { ArrowUpRight } from "lucide-react";

export const Contact = () => (
  <section
    id="enquire"
    data-testid="contact-section"
    className="bg-night text-cream px-6 md:px-12 py-28 md:py-40 lg:py-48"
  >
    <div className="max-w-6xl mx-auto grid md:grid-cols-12 gap-14 md:gap-20">
      <div className="md:col-span-5">
        <Reveal>
          <p className="text-xs md:text-sm uppercase tracking-[0.3em] text-gold font-medium mb-6">
            Begin the Conversation
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.05]">
            Your awakening deserves a{" "}
            <span className="italic text-sand">safe place</span> to land.
          </h2>
        </Reveal>
        <Reveal delay={0.18}>
          <p className="text-base md:text-lg text-cream/75 leading-relaxed mt-8 max-w-md">
            Share a little of where you are through a short enquiry form, and
            Amaléya will respond personally. If you'd like to feel into
            whether this journey is right for you, you can also request a free
            discovery call there.
          </p>
        </Reveal>
        <Reveal delay={0.26}>
          <p className="font-serif italic text-xl text-sand/90 mt-10">
            With love, presence, and care, Amaléya
          </p>
        </Reveal>
      </div>

      <Reveal delay={0.15} className="md:col-span-6 md:col-start-7">
        <div className="h-full flex flex-col justify-center border border-cream/20 rounded-2xl p-10 md:p-14">
          <span className="text-gold text-2xl">✦</span>
          <p className="font-serif text-3xl md:text-4xl mt-6 leading-tight">
            Begin with a short enquiry form.
          </p>
          <p className="text-cream/70 mt-4 leading-relaxed">
            A few gentle questions about where you are and what you're moving
            through. It opens in a new tab and takes only a few minutes.
            Amaléya reads every response personally.
          </p>
          <a
            data-testid="enquiry-form-link"
            href={GOOGLE_FORM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-10 inline-flex items-center gap-3 self-start rounded-full bg-gold text-soil text-xs uppercase tracking-[0.18em] px-10 py-4 hover:bg-amethyst hover:text-cream transition-colors duration-300"
          >
            Open the enquiry form
            <ArrowUpRight className="w-4 h-4" />
          </a>
        </div>

        <div
          data-testid="contact-qr-card"
          className="mt-8 border border-cream/20 rounded-2xl p-6 md:p-8 flex items-center gap-6"
        >
          <img
            src="/qr-code.png"
            alt="QR code that opens this page"
            data-testid="contact-qr-image"
            className="w-28 h-28 md:w-32 md:h-32 rounded-xl bg-cream p-2 shrink-0"
          />
          <div>
            <p className="text-xs uppercase tracking-[0.25em] text-gold">
              Share this page
            </p>
            <p className="text-cream/70 text-sm mt-2 leading-relaxed">
              Point your phone camera at the code to open this page, or pass it
              to a friend who may need it.
            </p>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
